import * as Yup from 'yup';
import { FC, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Typography,
  Autocomplete
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../../../common/SnackbarAlert';
import React from 'react';
import AutocompleteLoader from '../../../common/AutocompleteLoader';

type CreateEditProps = {
  closeCreateEditForm: any;
  productRateEditDatas: any;
  editStatus: boolean;
  productId: any;
  setNewValue?: Function;
};
const CreateEdit: FC<CreateEditProps> = ({
  closeCreateEditForm,
  productRateEditDatas,
  editStatus,
  productId,
  setNewValue
}) => {
  const ProductRateSchema = Yup.object().shape({
    productName: Yup.string()
      .required('Product Rate Name is required')

      // .trim('Product Rate Name cannot include leading and trailing spaces')
      // .strict(true)
      // .test(
      //   'notOnlyWhiteSpace',
      //   'Product Rate Name cannot include leading and trailing spaces..',
      //   (value) => {
      //     return !/\s{2,}/.test(value);
      //   }
      // )
      // .matches(/^[a-z0-9A-Z\s]+$/, 'Special characters are not allowed')
      .min(3, 'Product Rate Name must be at least 3 characters'),
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\<>]*$/,
      //   'Product Rate Name only accepts special characters like &,[,],-,/,(,),<,>'
      // )
      // .matches(
      //   /[a-zA-Z]/,
      //   'Product Rate Name must include at least one letter of the alphabet'
      // ),
    productCode: Yup.string()
      .required('Product Rate Code is required')
      // .trim('Product Rate Code cannot include leading and trailing spaces')
      // .strict(true)
      .test(
        'notOnlyWhiteSpace',
        'Product Rate Code cannot include leading and trailing spaces',
        (value) => {
          return !/\s{2,}/.test(value);
        }
      )
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-z0-9A-Z\s\-]+$/,
      //   'Invalid Product Rate Code. Only (-) character is allowed.'
      // )
      // .matches(
      //   /^[^-!@#$%^&*()_+={};:'",.<>/?\\|[\]`~].*$/,
      //   'Product Rate Code cannot start with a special character'
      // )
      .min(3, 'Product Rate Code must be at least 3 characters'),
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'Product Rate Code only accepts special characters like &,[,],-,/,(,)'
      // ),
    productRate: Yup.number()
      .notRequired()
      .typeError('Product Rate is not valid')
      .positive('Must be a positive number.')
      .min(1, 'Product Rate must be greater than or equal to 1')
      .transform((value, originalValue) => {
        return /\s/.test(originalValue) ? NaN : value;
      })
      .test('len', 'Length is too long', (val) => {
        if (val === undefined || val === null) return true;
        const valStr = val.toString();
        const maxLength = valStr.includes('.') ? 10 : 8;
        return valStr.length <= maxLength;
      })
      .test(
        'max-two-decimals',
        'Product Rate must have at most two decimal places',
        (value) => {
          if (value === undefined || value === null) return true;
          const decimalPlaces = value.toString().split('.')[1];
          return !decimalPlaces || decimalPlaces.length <= 2;
        }
      )
      .nullable()
    /// productId: Yup.number().required('Product is required')
  });
  const [isLoading, setLoading] = useState<boolean>(true);
  const [loader, setLoader] = useState<boolean>(false);
  const [productSearchValue, setProductSearchValue] = useState<string>('');
  const [showSnackBarAlert, setShowSnackBarAlert] = useState<{
    status: boolean;
    type: string;
    message: any;
  }>({
    status: false,
    type: 'success',
    message: null
  });
  const [productData, setProductData] = useState<any>([]);
  const [productValue, setProductValue] = useState<any>(null);
  const formik = useFormik({
    initialValues: {
      id: '',
      productName: '',
      productCode: '',
      productRate: '',
      status: true,
      productId: productId
    },
    validationSchema: ProductRateSchema,
    onSubmit: (values) => {
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      request({
        url: 'productRate',
        method: method,
        data: values
      })
        .then((productRate) => {
          if (productRate.status) {
            closeCreateEditForm(true);
            setLoader(false);
            if (setNewValue) {
              setNewValue(values?.productName);
            }
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: productRate['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (editStatus) {
    formik.values.id = productRateEditDatas.id;
    formik.initialValues.productName = productRateEditDatas.productName;
    formik.initialValues.productCode = productRateEditDatas.productCode;
    formik.initialValues.productRate = productRateEditDatas.productRate;
  }
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSearchValue]);
  const fetchProducts = async () => {
    request({
      url: 'policyProduct/getPolicyProductList',
      method: 'post',
      data: {
        search: productSearchValue,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: 0,
        limit: 100,
        status: true
      }
    }).then(
      (response) => {
        setProductData(response['policyProductData']);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (editStatus) {
      fetchPolicyProductNameById();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchPolicyProductNameById = async () => {
    request({
      url: 'policyProduct/getPolicyProductNameById',
      method: 'post',
      data: {
        id: productRateEditDatas?.productId
      }
    }).then(
      (response: any) => {
        formik.setValues((prev) => ({
          ...prev,
          productId: response?.id
        }));
        setProductSearchValue(response?.name);
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );
  };
  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              {editStatus ? (
                <CardHeader title="Update Product Rate" />
              ) : (
                <CardHeader title="Create Product Rate" />
              )}
              <Divider />

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Product Rate Name{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="productName"
                        value={capitalizeFirst(formik.values.productName)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('productName', trimmedValue);
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.productName &&
                          Boolean(formik.errors.productName)
                        }
                        helperText={
                          formik.touched.productName &&
                          formik.errors.productName
                        }
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Product Rate Code{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="productCode"
                        value={capitalizeFirst(formik.values.productCode)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('productCode', trimmedValue);
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.productCode &&
                          Boolean(formik.errors.productCode)
                        }
                        helperText={
                          formik.touched.productCode &&
                          formik.errors.productCode
                        }
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label={<React.Fragment>Product Rate </React.Fragment>}
                        sx={{ width: '100%' }}
                        size="small"
                        name="productRate"
                        type="number"
                        onKeyDown={(e) => {
                          if (['e', 'E', '-', '+'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.productRate}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          const formattedValue = e.target.value?.includes('.')
                            ? e.target.value.replace(
                                /(\.\d*?[1-9])0+$|\.0*$/,
                                '$1'
                              )
                            : e.target.value;
                          formik.setFieldValue(
                            'productRate',
                            formattedValue,
                            true
                          );
                          formik.handleBlur(e);
                        }}
                        error={
                          formik.touched.productRate &&
                          Boolean(formik.errors.productRate)
                        }
                        helperText={
                          formik.touched.productRate &&
                          formik.errors.productRate
                        }
                      />
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          type="submit"
                          variant="contained"
                        >
                          Save
                        </Button>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CreateEdit;
